<script>
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    emitter.on('newToastMessage', this.onNewToastMessage);
  },
  unmounted() {
    emitter.off('newToastMessage', this.onNewToastMessage);
  },
  methods: {
    onNewToastMessage({ message: originalMessage, action, type, title, description, persist }) {
      // FIX ME: This is a temporary workaround to pass string from functions
      // that doesn't have the context of the VueApp.
      const usei18n = action?.usei18n;
      const shouldPersist = Boolean(persist);
      const duration = action?.duration || this.duration;
      const processedMessage = usei18n ? this.$t(originalMessage) : originalMessage;
      
      // Support both old format (message) and new format (title)
      const processedTitle = title 
        ? (usei18n && typeof title === 'string' ? this.$t(title) : title)
        : processedMessage;
      const processedDescription = description 
        ? (usei18n && typeof description === 'string' ? this.$t(description) : description)
        : null;

      const toastType = type || 'info';
      
      // Prevent duplicate toasts: if same title and type exists, only reset timeout if toast is still new
      const existingToast = this.snackMessages.find(
        msg => msg.title === processedTitle && msg.type === toastType
      );

      if (existingToast) {
        if (!existingToast.persist && !shouldPersist) {
          // Only reset timeout if toast was created less than 500ms ago (prevent infinite reset)
          const toastAge = Date.now() - existingToast.key;
          if (toastAge < 500) {
            clearTimeout(existingToast.timeoutId);
            existingToast.timeoutId = window.setTimeout(() => {
              this.removeToast(existingToast.key);
            }, duration);
          }
        }
        return;
      }

      // No duplicate, create new toast
      const key = new Date().getTime();
      const timeoutId = shouldPersist
        ? null
        : window.setTimeout(() => {
            this.removeToast(key);
          }, duration);

      const todayText = this.$t('GENERAL.TODAY');

      this.snackMessages.push({
        key,
        message: processedMessage,
        title: processedTitle,
        description: processedDescription,
        type: toastType,
        action,
        timeoutId,
        todayText,
        persist: shouldPersist,
      });
    },
    removeToast(key) {
      const index = this.snackMessages.findIndex(msg => msg.key === key);
      if (index !== -1) {
        // Clear timeout if exists
        if (this.snackMessages[index].timeoutId) {
          clearTimeout(this.snackMessages[index].timeoutId);
        }
        this.snackMessages.splice(index, 1);
      }
    },
  },
};
</script>

<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="fixed top-4 right-4 max-w-[25rem] w-full sm:w-[25rem] overflow-visible z-[9999] flex flex-col items-end space-y-2"
  >
    <WootSnackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :title="snackMessage.title"
      :description="snackMessage.description"
      :type="snackMessage.type"
      :action="snackMessage.action"
      :today-text="snackMessage.todayText"
      @close="removeToast(snackMessage.key)"
    />
  </transition-group>
</template>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(12px);
}
</style>